import React, { useState, useMemo, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Grid, Typography } from "@material-ui/core";
import { set_filters } from "../../store/actions/action";
import {   TEXT_COLOR } from "../../utils/constant";
import { IMG_URL } from "../../utils/constant";

const ItemCategory = function (props) {
  const paragraphRefs = useRef([]);

  const {
    appliedfilters,
    filterItems,
    selectedMasterCategory,
    setSelectedSubCategory,
    setOpenedIndex,
    allCategoryList,storeInfo
  } = props;

  const [loading, setLoading] = useState(false);

  const handleCategoryClick = async (obj, type) => {
    setOpenedIndex(null);
    setLoading(true);
    await filterItems(obj, type);

    if (type === "All_Item") {
      setSelectedSubCategory(allCategoryList);
    } else {
      setSelectedSubCategory(
        allCategoryList.filter(
          (e) => e.master_category_id === obj.master_category_id
        )
      );
    }
    setLoading(false);
  };

  const selectCategory = selectedMasterCategory || "All_Item";

  const categorySeq = useMemo(() => {
    return allCategoryList.sort((a, b) => {
      const catA = a.cat_sequence_no || 0;
      const catB = b.cat_sequence_no || 0;
      return catA - catB;
    });
  }, [allCategoryList]);

  const uniqueData = useMemo(() => {
    const masterCategoryIds = new Set();
    return categorySeq.filter((item) => {
      if (!masterCategoryIds.has(item.master_category_id)) {
        masterCategoryIds.add(item.master_category_id);
        return true;
      }
      return false;
    });
  }, [categorySeq]);

  const getCategoryStyle = (index) => ({
    position: "relative", // Position relative to contain the pseudo-element
    margin: "0.4rem",
    display: "flex",
    borderRadius: "8px",
    padding: "10px",
    minHeight: "80px",
    minWidth: "200px",
    maxHeight: "80px",
    maxWidth: "200px",
    boxShadow: "0px 4px 4px 0px #00000040",
    border: selectCategory === index ? `1px solid ${ storeInfo?.secondary_color || TEXT_COLOR}` : "",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden", // Hide overflow for the pseudo-element
  });

  const backgroundImageStyle = (imgUrl) => ({
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: `url(${imgUrl})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    opacity: 0.4,
    zIndex: 1, // Ensure it's behind the text
  });

  const selectedStyle = (index) => ({
    fontWeight: 700,
    color:   storeInfo?.secondary_color || TEXT_COLOR,
    fontFamily: "Nunito",
    fontSize: "20px",
    lineHeight: "20px",
    textAlign: "center",
    textTransform: "capitalize",
    zIndex: 2, // Ensure it's above the background image
    position: "relative", // Position relative to contain the text within the div
  });

  const scrollToItem = (index) => {
    paragraphRefs.current[index]?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest",
    });
  };

  useEffect(() => {
    if (uniqueData?.length > 0) {
      handleCategoryClick(uniqueData[0], "MasterCategory");
      scrollToItem(1);
    }
  }, [uniqueData]);

  return (
    <>
      <div>
        <Grid
          className="example"
          style={{
            overflow: "scroll",
            display: "flex",
            width: "100%",
            scrollbarWidth: "none",
          }}
        >
    <div style={{ marginTop: "1rem", display: "flex" ,paddingLeft:"1rem"}}>
            {uniqueData?.map((obj, index) => (
              <Grid
                key={obj.master_category_id}
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  flexDirection: "column",
                  marginRight: "1rem", // Gap between boxes
                }}
              >
                <div
                  ref={(el) => (paragraphRefs.current[index + 1] = el)}
                  style={getCategoryStyle(obj.master_category_id)}
                  onClick={() => {
                    handleCategoryClick(obj, "MasterCategory");
                    scrollToItem(index + 1);
                  }}
                >
                  {(() => {
                    if (!obj?.cat_img) return null;
                    const sid = String(obj?.store_id || '').trim();
                    const rawImg = String(obj.cat_img).trim().replace(/^\/+/, '');
                    const baseUrl = (IMG_URL || '').replace(/\/+$/, '');
                    const imgSrc = (rawImg.startsWith('http://') || rawImg.startsWith('https://'))
                      ? rawImg
                      : (sid && !rawImg.startsWith(`${sid}/`))
                      ? `${baseUrl}/${sid}/${rawImg}`
                      : `${baseUrl}/${rawImg}`;
                    return <div style={backgroundImageStyle(imgSrc)} />;
                  })()}
                  <Grid
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                      zIndex: 2, // Ensure the content is above the background
                      position: "relative", // Position relative to contain the text
                    }}
                  >
                    <div
                      style={{
                        // backgroundColor: "rgba(0, 0, 0, 0.3)",
                        padding: "5px",
                        borderRadius: "5px",
                      }}
                    >
                      <Typography
                        style={{
                          display: "flex",
                          width: "max-content",
                          textTransform: "capitalize",
                          maxWidth: "180px",
                          color:   storeInfo?.secondary_color || TEXT_COLOR,
                          textShadow: "1px 1px 2px rgba(0, 0, 0, 0.8)",
                        }}
                        key={obj.master_category_id}
                      >
                        <span style={selectedStyle(obj.master_category_id)}>
                          {obj.master_category_name}
                        </span>
                      </Typography>
                    </div>
                  </Grid>
                </div>
              </Grid>
            ))}
          </div>
        </Grid>
      </div>

      {loading && <div>Loading Categories...</div>}
    </>
  );
};

const mapStateToProps = (state) => ({
  appliedfilters: state.filterReducer,
});

const mapDispatchToProps = (dispatch) => ({
  set_filters: (obj) => {
    dispatch(set_filters(obj));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ItemCategory);
